import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { MatomoProvider, createInstance } from "@jonkoops/matomo-tracker-react";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const instance = createInstance({
  urlBase: "https://analytics.key-biz.cloud",
  siteId: 1,
  heartBeat: {
    // optional, enabled by default
    active: true, // optional, default value: true
    seconds: 10, // optional, default value: `15
  },
  linkTracking: true, // optional, default value: true
  configurations: {},
});

root.render(
  <MatomoProvider value={instance}>
    <App />
  </MatomoProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
